import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { ButtonsWrapper } from 'src/domains/layouts/shared/buttons/Button.style';

interface UploadImageType {
    hasFullWidthPreview?: boolean;
}

export const UploadWrapper = styled('div', { label: 'UploadWrapper' })<UploadImageType>`
    ${({ hasFullWidthPreview }): string => hasFullWidthPreview !== true ? `
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-end;
    ` : ''};
    margin: 4px 0 16px 0;
`;

export const ImgPlaceholder = styled('div', { label: 'ImgPlaceholder' })<UploadImageType>`
    font-family: var(--fontFamilyPrimary);
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    color: ${mainColors.main.primary};
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    background-color: ${lpPageColors.paleGrey};
    ${({hasFullWidthPreview}): string => hasFullWidthPreview === true ? 'width: 100%; margin-bottom: 8px;' : 'width: 140px;'}
    height: 80px;
    border-radius: 8px;
    border: 2px solid ${mainColors.main.primary};
`;

export const ImgItem = styled('img', { label: 'ImgItem' })<UploadImageType>`
    ${({hasFullWidthPreview}): string => hasFullWidthPreview === true ? `
        width: auto;
        max-width: 100%;
        height: auto;
    ` : `
        width: 140px;
        height: 80px;
    `}
    object-fit: fill;
    border-radius: 8px;
    border: 2px solid ${mainColors.main.primary};
`;

export const UploadButtonsWrapper = styled(ButtonsWrapper, { label: 'UploadButtonsWrapper' })`
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-end;
`;

export const UploadButtonWrapper = styled('label', { label: 'UploadButtonWrapper' })<UploadImageType>`
    ${({ hasFullWidthPreview }): string => hasFullWidthPreview === true ? '' : 'margin-left: 8px'};
    cursor: pointer;
    margin-right: 8px;
    &:hover {
        button {
            opacity: 0.8;
            pointer-events: none;
        }
    }
`;

// use ::file-selector-button to style this component
export const UploadInput = styled('input', { label: 'UploadInput' })`
    display: none;
`;

export const WarningMessageWrapper = styled('div', { label: 'WarningMessageWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    background-color: ${lpPageColors.homepageWarningColor};
    gap: 16px;
    padding: 16px;
`;
